import { Game } from './Game';
import { AudioManager } from './systems/AudioManager';

// Entry point - initialize and start the game
const canvas = document.getElementById('game') as HTMLCanvasElement;

if (!canvas) {
  console.error('Canvas element not found!');
  throw new Error('Canvas element with id "game" not found');
}

// Initialize audio manager
const audioManager = new AudioManager();

// Setup start button
const startButton = document.getElementById('startButton') as HTMLButtonElement;
if (startButton) {
  startButton.addEventListener('click', () => {
    // Start music
    audioManager.play();
    
    // Hide start button
    startButton.classList.add('hidden');
    
    // Trigger game start
    window.dispatchEvent(new CustomEvent('startGame'));
  });
}

// Listen for music start event from menu
window.addEventListener('startMusic', () => {
  audioManager.play();
});

const game = new Game(canvas, audioManager);
game.start();

console.log('🎮 Hands Across America - Game Started!');

// Wire mobile joystick/fire controls (from index.html) into the game's Input system
const input = game.getInput();
const joystickEl = document.getElementById('virtualJoystick');
const fireEl = document.getElementById('fireButton');
if (joystickEl) {
  joystickEl.addEventListener('joymove', (ev: any) => {
    const d = ev.detail || { x: 0, y: 0 };
    // Feed analog axis into Input.touchAxis so movement can be multidirectional
    input.touchAxis.x = d.x;
    input.touchAxis.y = d.y;
  });
  joystickEl.addEventListener('joyend', () => {
    input.touchAxis.x = 0;
    input.touchAxis.y = 0;
  });
}
if (fireEl) {
  fireEl.addEventListener('fire', () => {
    // Pulse the touchFire flag for a short duration so the game's update loop detects it
    input.touchFire = true;
    setTimeout(() => { input.touchFire = false; }, 120);
  });
}
